module.exports = __webpack_public_path__ + "media/about-direct-school.8ed23c60.mp4";